import { render, staticRenderFns } from "./HTMLCard.vue?vue&type=template&id=66568efe&"
import script from "./HTMLCard.vue?vue&type=script&lang=js&"
export * from "./HTMLCard.vue?vue&type=script&lang=js&"
import style0 from "./HTMLCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports